import { render, staticRenderFns } from "./ViewPropertyChangeRequests.vue?vue&type=template&id=bc3a3182"
import script from "./ViewPropertyChangeRequests.vue?vue&type=script&lang=ts"
export * from "./ViewPropertyChangeRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports